<template>
  <div class="finance-summary-card" v-loading="loading">
    <div class="card-item" v-for="item in cards" :key="item.key">
      <div class="card-label">{{ item.label }}</div>
      <div class="card-value" :class="item.class">{{ item.prefix }}{{ formatVal(item.value) }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FinanceSummaryCard',
  props: {
    summaryUrl: { type: String, required: true },
    params: { type: Object, default: () => ({}) },
    type: { type: String, default: 'bus' }
  },
  data() {
    return {
      loading: false,
      summary: {}
    }
  },
  computed: {
    cards() {
      const s = this.summary
      if (this.type === 'hitchRide') {
        return [
          { key: 'orderCount', label: '订单总数', value: s.orderCount, prefix: '', class: '' },
          { key: 'totalRealFee', label: '实收总额', value: s.totalRealFee, prefix: '￥', class: 'money' },
          { key: 'totalDriverIncome', label: '司机收入', value: s.totalDriverIncome, prefix: '￥', class: 'money-green' },
          { key: 'totalCompanyIncome', label: '平台收入', value: s.totalCompanyIncome, prefix: '￥', class: 'money-blue' },
          { key: 'totalServiceFee', label: '信息费', value: s.totalServiceFee, prefix: '￥', class: '' },
          { key: 'totalCouponFee', label: '优惠券折扣', value: s.totalCouponFee, prefix: '￥', class: 'money-red' }
        ]
      }
      return [
        { key: 'orderCount', label: '订单总数', value: s.orderCount, prefix: '', class: '' },
        { key: 'totalRealFee', label: '实收总额', value: s.totalRealFee, prefix: '￥', class: 'money' },
        { key: 'totalDriverIncome', label: '司机收入', value: s.totalDriverIncome, prefix: '￥', class: 'money-green' },
        { key: 'totalCompanyIncome', label: '平台收入', value: s.totalCompanyIncome, prefix: '￥', class: 'money-blue' },
        { key: 'totalRefundFee', label: '退款总额', value: s.totalRefundFee, prefix: '￥', class: 'money-red' },
        { key: 'totalCouponFee', label: '优惠券折扣', value: s.totalCouponFee, prefix: '￥', class: '' }
      ]
    }
  },
  watch: {
    params: {
      handler() {
        this.load()
      },
      deep: true
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      if (!this.params.appKey) return
      this.loading = true
      const res = await this.$axios.get(this.summaryUrl, { ...this.params })
      if (res && res.code === 1 && res.data) {
        this.summary = res.data
      }
      this.loading = false
    },
    formatVal(val) {
      if (val === null || val === undefined) return '-'
      if (typeof val === 'number' || !isNaN(Number(val))) {
        const num = Number(val)
        return num % 1 === 0 ? num.toString() : num.toFixed(2)
      }
      return val
    }
  }
}
</script>

<style lang="less" scoped>
.finance-summary-card {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
  padding: 12px;
  background: #f8f9fb;
  border-radius: 8px;
  border: 1px solid #EBEEF5;

  .card-item {
    flex: 1;
    min-width: 120px;
    text-align: center;
    padding: 8px 12px;
    background: #fff;
    border-radius: 6px;
    border: 1px solid #EBEEF5;

    .card-label {
      font-size: 12px;
      color: #909399;
      margin-bottom: 4px;
    }

    .card-value {
      font-size: 18px;
      font-weight: 700;
      color: #303133;

      &.money { color: #E6A23C; }
      &.money-green { color: #67C23A; }
      &.money-blue { color: #409EFF; }
      &.money-red { color: #F56C6C; }
    }
  }
}
</style>
